import * as React from 'react';
export interface ListingNameProps {
  name: string;
  ariaHidden?: boolean;
  visuallyHidden?: boolean;
}

export const ListingName: React.FunctionComponent<ListingNameProps> = ({ name, ariaHidden = false, visuallyHidden = false }) => (
  <h3
    className="pwa-theme--grey-900 truncate all-b-padding-half uitk-type-heading-500"
    data-stid="content-hotel-title"
    aria-hidden={ariaHidden}
    hidden={visuallyHidden}
  >
    {name}
  </h3>
);
ListingName.displayName = 'ListingName';
